module.exports = __webpack_public_path__ + "static/media/We Got Love.6e1aca8b.jpg";